var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:{active: _vm.isLoading}},[_vm._v(_vm._s(_vm.$t('loading'))+" "+_vm._s(_vm.loadingProgress))])
}
var staticRenderFns = []

export { render, staticRenderFns }